import React, { useEffect, useCallback } from 'react'
import { accountService } from '../services/accountService'
import { mondayService } from '../services/mondayService'

export const useGetAccount = (mondayAccountId: number | undefined, setAccount: React.Dispatch<React.SetStateAction<any>>, accessToken: string | undefined, setMondayError: React.Dispatch<React.SetStateAction<boolean>>): void => {
  const getAccount = useCallback(async (accessToken: string) => {
    const account: Account = await accountService.getAccount(mondayAccountId!, accessToken)

    if(!account.mondayDomain) { // new account
      const accountInformation = await mondayService.getAccountInformation(setMondayError)
      const { mondayDomain, company, userId, userEmail, userName, mondayNumOfUsers } = accountInformation!
      account.mondayDomain = mondayDomain
      account.company = company
      account.mondayNumOfUsers = mondayNumOfUsers

      if(!account.users.length) {
        account.users.push({userId, userEmail, userName, ticketsSent: 0})
      }
      await accountService.updateAccount(account, accessToken)
    }
    setAccount(account)
  }, [mondayAccountId, setAccount, setMondayError])

  useEffect(() => {
    (mondayAccountId && accessToken) && getAccount(accessToken)
  }, [mondayAccountId, accessToken, getAccount])

}
